import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { Button, Grid } from "semantic-ui-react";
import { useStore } from "../../stores/store";
import { Application } from "../../models/enums";
import { useTranslation } from "react-i18next";

type Props = {
  onClose?: () => void;
  hideCloseIcon?: boolean;
};

export function NotificationMessage({
  children,
  onClose,
  hideCloseIcon,
}: React.PropsWithChildren<Props>) {
  return (
    <div className="ui nag blue RemoveTopBottomPadding">
      {children}
      {!hideCloseIcon && <i onClick={onClose} className="close icon"></i>}
    </div>
  );
}

export default observer(function NotificationMessages() {
  const { t } = useTranslation(["common", "recentTickets"]);
  const { inventorySettingsStore, userStore } = useStore();
  const {
    loadInventoryReminders,
    getInventoryReminders,
    cancelInventoryReminders,
    hideInventoryReminders,
  } = inventorySettingsStore;
  const { checkApplication } = userStore;
  useEffect(() => {
    loadInventoryReminders();
  }, [loadInventoryReminders]);

  return (
    <>
      {checkApplication(Application.AutomotiveExpert) &&
      getInventoryReminders &&
      getInventoryReminders.length &&
      !hideInventoryReminders ? (
        <NotificationMessage onClose={() => cancelInventoryReminders()}>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column width={10} verticalAlign="middle"  textAlign="left">
                <h4 className="text-white">
                  {t("lowInventoryNotification1", { ns: "inventory" })}{" "}
                  {getInventoryReminders.length}{" "}
                  {t("lowInventoryNotification2", { ns: "inventory" })}
                </h4>
              </Grid.Column>
              <Grid.Column textAlign="right" width={6} verticalAlign="middle">
                <Button
                  varient="link"
                  onClick={() =>
                    window.open(`/reports/inventoryOrderList?showAll=true`)
                  }
                  variant="link"
                >
                  {t("seeReport", { ns: "inventory" })}
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </NotificationMessage>
      ) : null}
    </>
  );
});
